import clientIcon from '../../../images/clientIcon.png'
import botIcon from '../../../images/logo-icon.png'

const ClientMessage = ({ message }) => {
	if (!message.sent_at) {
		message.sent_at = new Date().toISOString()
	}
	console.log(message.sent_at)
	const sent_by_check = message.sent_by.split('@')[1]

	return (
		<div
			className={`messageContainer ${
				sent_by_check === 'schiefler.adv.br' ? 'botMessageContainer' : 'clientMessageContainer'
			}`}
		>
			<span className={`message ${sent_by_check === 'schiefler.adv.br' ? 'botMessage' : 'clientMessage'}`}>
				{message.text}
				{message.sent_at ? <span className="time">{message?.sent_at.slice(11, 16)}</span> : ''}
			</span>
		</div>
	)
}
export default ClientMessage
